// UpdatePostPage.js
import { useParams } from "react-router-dom";
import PostRenderer from "./PostRenderer";

const UpdatePostPage = () => {
  const { slug } = useParams();
  return <PostRenderer slug={slug} folderName="updates" />;
};

export default UpdatePostPage;
